import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f716de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-tags me-2" }),
    /*#__PURE__*/_createTextVNode("โครงการตามยุทธศาสตร์จังหวัดและกลุ่มจังหวัด")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลโครงการตามยุทธศาตร์จังหวัดและกลุ่มจังหวัด")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProvinceTaskTableComponent = _resolveComponent("ProvinceTaskTableComponent")!
  const _component_ProvinceFilterComponent = _resolveComponent("ProvinceFilterComponent")!
  const _component_ProvinceTaskFormComponent = _resolveComponent("ProvinceTaskFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProvinceFilterComponent, { onChange: _ctx.filterChange }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-primary mb-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
            }, [
              _hoisted_4,
              _createTextVNode("เพิ่มโครงการฯ ")
            ]),
            _createVNode(_component_ProvinceTaskTableComponent, {
              "province-task-type-id": 1,
              "fiscal-year-id": _ctx.fiscalYearId,
              "province-id": _ctx.provinceId
            }, null, 8, ["fiscal-year-id", "province-id"])
          ]),
          _: 1
        }, 8, ["onChange"])
      ])
    ]),
    _createVNode(_component_ProvinceTaskFormComponent, {
      ref: "provinceTaskForm",
      "province-task-type-id": 1,
      "province-id": _ctx.provinceId,
      "province-task-id": _ctx.selectedProvinceTaskId
    }, null, 8, ["province-id", "province-task-id"])
  ], 64))
}